import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Column, Row } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import {
  renderDatepickerWithLabel,
  renderInputWithLabel,
  renderSelectWithLabel,
} from "../../../components/form/FormComponent";
import {
  listActivity,
  detailActivity,
} from "../../../actions/master-data/activity_action";
import {
  getActivityPending,
  getDetailActivity,
} from "../../../reducers/master-data/activity_reducer";
import { uploadP2kb } from "../../../actions/p2kb/p2kb_action";
import {
  getP2kbUploadPending,
  getP2kbUpload,
} from "../../../reducers/p2kb/p2kb_reducer";
import DetailContentLihatBerkas from "../../../components/detail/DetailContentLihatBerkas";
import ModalDocument from "../../../components/modal/ModalDocument";
import Loading from "../../../components/global-components/LoadingComponent";

class MenulisIlmiahModalDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDocument: false,
      values_id: "",
      berkas: null,
      berkas_disabled: false,
      isDoneUploading: true,
      skp: 0,
      filename: "",
      modal_title: "",
      selected_activity: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeValues = this.handleChangeValues.bind(this);
    this.handleChangeLastActivity = this.handleChangeLastActivity.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { reset, show } = this.props;
    if (prevProps.show !== show && show === true) {
      reset();
      if (this.props.initialValues.berkas) {
        this.setState({
          berkas: (
            <DetailContentLihatBerkas
              onClick={() =>
                this.handleOpenDocument(this.props.formValue, "Berkas Bukti")
              }
            />
          ),
        });
      }
    }
  }

  handleOpenDocument(filename, modalTitle) {
    this.setState({
      filename: filename,
      modalTitle: modalTitle,
      showDocument: true,
    });
  }

  handleChangeLastActivity(values) {
    const {
      values: [{ skp_must_be_multipied, value_multipied, value_skp, id }],
    } = values;

    this.setState({ values_id: id });
    if (skp_must_be_multipied === 0) {
      this.props.change("skp_total", value_skp);
    } else {
      this.props.change("skp_total", Math.round(value_skp * value_multipied));
    }
  }

  handleChangeValues(values) { }

  handleUploadFile(values) {
    const formName = values.target.name;
    this.setState({
      isDoneUploading: false,
      berkas_disabled: true,
      [formName]: <Loading />,
    });

    const callback = () => {
      this.setState({ isDoneUploading: true, berkas_disabled: false });
      if (this.props.uploadP2kb_data) {
        this.props.change(formName, this.props.uploadP2kb_data);
        this.setState({ berkas: <Loading done={true} /> });
        setTimeout(
          () =>
            this.setState({
              [formName]: (
                <DetailContentLihatBerkas
                  onClick={() =>
                    this.handleOpenDocument(
                      this.props.formValue,
                      "Berkas Bukti"
                    )
                  }
                />
              ),
            }),
          2000
        );
      }
    };
    const error = () => {
      this.setState({ isDoneUploading: true, berkas_disabled: false });
      if (this.props.uploadP2kb_error) {
        this.props.change([formName], null);
        this.setState({
          [formName]: <Loading done={true} failed={true} />,
        });
      }
    };
    this.props.uploadP2kb(values.target.files[0], callback, error);
  }

  handleSubmit(values) {
    const { values_id } = this.state;
    const result = { ...values, values_id: values_id };
    this.props.handleDetailSkp(result);
    this.props.onHide();
  }

  render() {
    const {
      show,
      onHide,
      handleSubmit,
      detailActivity_data,
    } = this.props;
    const { berkas, showDocument, filename, modalTitle } = this.state;
    let currentYear = new Date().getFullYear();
    let yearOptions = [];
    let lastActivityOptions = [];
    for (let i = currentYear; i >= 1900; i--) {
      yearOptions = [...yearOptions, { label: i, value: i }];
    }
    if (detailActivity_data && detailActivity_data.lenght !== 0) {
      lastActivityOptions = detailActivity_data[0].childrens.map(
        ({ id, values, name }) => ({ value: id, label: name, values: values })
      );
    }

    return (
      <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalDocument
          show={showDocument}
          onHide={() => this.setState({ showDocument: false })}
          filepath="member_p2kb"
          filename={filename}
          modalTitle={modalTitle}
        />

        <Modal.Header closeButton>
          <p style={{ fontSize: 20, fontWeight: 600 }}>Detail SKP</p>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={handleSubmit(this.handleSubmit)}
            style={{ width: "100%" }}
          >
            <Column
              vertical="center"
              horizontal="stretch"
              className={css(styles.bodyModal)}
            >
              <Field
                isDetail
                name="activity_date"
                placeholder="Masukkan tanggal kegiatan"
                label="Tanggal Kegiatan"
                component={renderDatepickerWithLabel}
              />
              <Field
                disable
                name="title_of_paper"
                placeholder="Masukkan judul makalah"
                label="Judul Makalah"
                component={renderInputWithLabel}
              />
              <Field
                isDisabled
                name="last_activity"
                placeholder="Pilih tingkat"
                label="Tingkat"
                options={lastActivityOptions}
                onChange={this.handleChangeLastActivity}
                component={renderSelectWithLabel}
              />
              <Field
                disable
                name="magazine_name"
                placeholder="Masukkan nama majalah"
                label="Nama Majalah"
                component={renderInputWithLabel}
              />
              <Field
                disable
                name="number"
                placeholder="Masukkan volume/nomor"
                label="Volume/Nomor"
                component={renderInputWithLabel}
              />
              <Field
                isDisabled
                name="publication_year"
                placeholder="Pilih tahun"
                label="Tahun Terbit"
                component={renderSelectWithLabel}
                options={yearOptions}
              />
              <Field
                disable
                name="issn_number"
                placeholder="Masukkan nomor ISSN"
                label="Nomor ISSN"
                component={renderInputWithLabel}
              />
              <Field
                disable
                name="publisher"
                placeholder="Masukkan penerbit"
                label="Penerbit"
                component={renderInputWithLabel}
              />
              <Field
                disable
                name="site_address"
                placeholder="Masukkan alamat situs"
                label="Alamat Situs"
                component={renderInputWithLabel}
              />
              <Field
                disable
                name="skp_total"
                placeholder="Jumlah SKP"
                label="Jumlah SKP"
                component={renderInputWithLabel}
              />
              <Row horizontal="space-between" style={{ marginTop: "10px" }}>
                <label>Berkas Bukti</label>
                {berkas}
              </Row>
            </Column>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

const styles = StyleSheet.create({
  approveButton: {
    background: "#2CB96A 0% 0% no-repeat padding-box",
    boxShadow: "none",
  },
  rejectButton: {
    background: "#EAEBED 0% 0% no-repeat padding-box",
    marginRight: 10,
    color: "#495057",
    boxShadow: "none",
  },
  footerModal: {
    backgroundColor: "#FBFBFD",
    padding: "20px 40px",
  },
  bodyModal: {
    padding: "0px 40px 20px",
    width: "100%",
  },
});



MenulisIlmiahModalDetail = reduxForm({
  form: "MenulisIlmiahModalDetail",
  shouldError: () => true,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(MenulisIlmiahModalDetail);

function mapStateToProps(state) {
  const { listActivity, uploadP2kb, detailActivity, selectedSKP } = state;
  const selector = formValueSelector("MenulisIlmiahModalDetail");
  const formValue = selector(state, "berkas");
  let initialValues = {};
  if (selectedSKP) {
    initialValues = selectedSKP;
  }
  return {
    listActivity_pending: getActivityPending(listActivity),
    detailActivity_data: getDetailActivity(detailActivity),
    uploadP2kb_pending: getP2kbUploadPending(uploadP2kb),
    uploadP2kb_data: getP2kbUpload(uploadP2kb),
    formValue,
    initialValues,
  };
}

export default connect(mapStateToProps, {
  listActivity,
  detailActivity,
  uploadP2kb,
})(withRouter(MenulisIlmiahModalDetail));
